import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetSessions, GetSessionsResponse, Registration } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetSessionsResponse, GetSessionsResponse>) => response?.data?.sessions;

const getError = (response?: SWRResponse<GetSessionsResponse, GetSessionsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetSessionsResponse, GetSessionsResponse>) => ({
    sessions: response?.data?.sessions
});

export const useRegistrationDeskSessions = (id?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        
        return () => {
            return new GetSessions({});
        };
    }, [id])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useRegistrationDeskSessions;
